import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import TopBanner from './components/TopBanner';
import Header from './components/Header';
import Footer from './components/Footer';
import SEO from './components/SEO';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import PaypalReturnPage from './pages/PaypalReturnPage';
import AboutPage from './pages/AboutPage';
import COAsPage from './pages/COAsPage';
import NewsPage from './pages/NewsPage';
import TrackOrderPage from './pages/TrackOrderPage';
import ContactPage from './pages/ContactPage';
import AccountPage from './pages/AccountPage';
import MaintenancePage from './pages/MaintenancePage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminLabels from './pages/admin/AdminLabels';
import AdminOrders from './pages/admin/AdminOrders';
import AdminNews from './pages/admin/AdminNews';
import AdminContacts from './pages/admin/AdminContacts';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import PageTracker from './lib/analytics';
import { getSettings } from './lib/api';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const [maintenance, setMaintenance] = useState(null);

  useEffect(() => {
    getSettings()
      .then((s) => setMaintenance(!!s.maintenance))
      .catch(() => setMaintenance(false));
  }, [pathname]);

  if (isAdmin) return children;
  if (maintenance === null) return null; // avoid flash of storefront while resolving
  if (maintenance) return <MaintenancePage />;

  return (
    <>
      <TopBanner />
      <Header />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <PageTracker />
          <SEO />
          <PublicLayout>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route path="/checkout/paypal-return" element={<PaypalReturnPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/coas" element={<COAsPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/track" element={<TrackOrderPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/account" element={<AccountPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="labels" element={<AdminLabels />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="contacts" element={<AdminContacts />} />
                <Route path="analytics" element={<AdminAnalytics />} />
              </Route>
            </Routes>
          </PublicLayout>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
